export default __webpack_public_path__ + "static/media/bell.d855f97c.PNG";